import Vue from 'vue'
import VueRouter from 'vue-router'
import requireAuth from './requireAuth'
import cannotShare from './cannotShare'
import login from '../pages/login-page.vue'
import quicklyRegister from './../pages/quicklyRegister/quicklyRegister'
import { webTracing } from '@gyasset/shared/utils';
import { webTracingConfig } from './webTracingConfig'
import { windowMatchMobile, toCamelCase } from "@/util";

let pdfView = (resolve) => {
  return require.ensure([], () => {
    console.log('pdfView')
    resolve(require('../pages/pdf-view.vue'))
  }, 'pdfView')
}
let wechat = () => import('../pages/login/wechat.vue')
let wechatRedirect = () => import('../pages/login/wechatRedirect.vue')
let wechatConfirm = () => import('../pages/login/wechatConfirm.vue')
let agreementPage = () => import('../pages/agreement-page')
let agreementDialogPage = () => import('../pages/agreement-dialog')
let tokenRedirect = () => import('../pages/login/tokenRedirect.vue')
let riskEvaluation = () => import('../pages/investorInfo/risk-evaluation.vue')
let fillInfo = () => import('../pages/investorInfo/fillInfoPage.vue')
const ProductDetail = () => import('../pages/mine/productDetail/product-detail.vue')
let propertyDetailsMobile = () => import('../pages/myProperties/propertyDetailsMobile.vue')
let productElements = () => import('../pages/mine/product-detail/product-elements.vue')
let productReports = () => import('../pages/mine/product-detail/product-reports.vue')
let productDetails = () => import('../pages/mine/product-detail/product-details.vue')
let purchaseStatusWait = () => import('../pages/mine/purchaseStatusWait.vue')
let addFund = () => import('../pages/mine/addFund.vue')
let Register = () => import('../pages/register/register.vue')
let findPassword = () => import('../pages/register/findPassword.vue')
let findPasswordOne = () => import('../pages/register/findPasswordOne.vue')
let findPasswordTwo = () => import('../pages/register/findPasswordTwo.vue')
let findPasswordThree = () => import('../pages/register/findPasswordThree.vue')
let findPasswordFour = () => import('../pages/register/findPasswordFour.vue')
let findPasswordAgreement = () => import('../pages/register/findPasswordAgreement.vue')
let myProperties = () => import('../pages/myProperties/myProperties.vue')
let personalData = () => import('../pages/myProperties/personalData.vue')
let editPassword = () => import('../pages/myProperties/editPassword.vue')
let personalInfo = () => import('../pages/myProperties/personalInfo.vue')
//todo 两个入口 交易记录  手机端  我的交易
let HistoryTabRoute = () => import('../pages/myProperties/historyTab.vue')
let historyDetails = () => import('../pages/myProperties/historyDetailsPage.vue')
let myPropertiesTab = () => import('../pages/myProperties/myPropertiesTab.vue')
// 扫码进入我的资产
const directMyPropertiesTab = () => import('../pages/myProperties/myPropertiesTab.vue')
let MyAttentionTab = () => import('../pages/myProperties/myAttentionTabPage.vue')
const PropertyDetails = () => import('../pages/myProperties/propertyDetails.vue')
let waitingForAsync = () => import('../pages/waitingForAsync.vue')
let registMobileOne = () => import('../pages/register/registMobileOne.vue')
let registMobileTwo = () => import('../pages/register/registMobileTwo.vue')
let registMobileThree = () => import('../pages/register/registMobileThree.vue')
let mobileRiskRemind = () => import('../pages/mobileInvestorInfo/risk-remind-page.vue')
let investorResult = () => import('../pages/mobileInvestorInfo/investor-result-page.vue')
let mobileQuestionnaire = () => import('../pages/mobileInvestorInfo/questionnairePage.vue')
let questionnaireResult = () => import('../pages/mobileInvestorInfo/questionnaire-result-page.vue')
let mobileRiskInvestor = () => import('../pages/mobileInvestorInfo/risk-investor-page.vue')
let historyAsset = () => import('../pages/myProperties/historyAssetPage.vue')
let historyNav = () => import('../pages/mine/productDetail/historyNav.vue')
let changeEmail = () => import('../pages/myProperties/changeEmailPage.vue')
let changeAddress = () => import('../pages/myProperties/changeAddressPage.vue')
let passwordAll = () => import('../pages/myProperties/password/passwordAll.vue')
let changePasswordOne = () => import('../pages/myProperties/password/changePasswordOne.vue')
let changePasswordTwo = () => import('../pages/myProperties/password/changePasswordTwo.vue')
let onPassageApplication = () => import('../pages/mine/application/onPassageApplicationPage.vue')
let historyApplication = () => import('../pages/mine/application/historyApplicationPage.vue')
let applicationDetail = () => import('../pages/mine/application/applicationDetail.vue')
let applicationDetailWeb = () => import('../pages/mine/application/applicationDetailWeb.vue')
let redeem = () => import('../pages/myProperties/application/redeem/redeem.vue')
let redeemFillInfo = () => import('../pages/myProperties/application/redeem/redeemFillInfoPage.vue')
let redeemVerify = () => import('../pages/myProperties/application/redeem/redeemVerify.vue')
let redeemComplete = () => import('../pages/myProperties/application/redeem/mobile/redeemComplete.vue')
let cancellation = () => import('../pages/myProperties/application/cancellation/cancellation.vue')
let cancellationVerify = () => import('../pages/myProperties/application/cancellation/cancellationVerify.vue')
let cancellationComplete = () => import('../pages/myProperties/application/cancellation/cancellationComplete.vue')
let appendVerify = () => import('../pages/myProperties/application/append/appendVerify.vue')
let amend = () => import('../pages/myProperties/application/amend/amend.vue')
let amendVerify = () => import('../pages/myProperties/application/amend/amendVerify.vue')
let amendFillInfo = () => import('../pages/myProperties/application/amend/amendFillInfo.vue')
let amendComplete = () => import('../pages/myProperties/application/amend/amendComplete.vue')
let purchase = () => import('../pages/myProperties/application/purchase/purchase.vue')
let purchaseConfirmInfo = () => import('../pages/myProperties/application/purchase/mobile/purchaseConfirmInfo.vue')
let purchaseFillInfo = () => import('../pages/myProperties/application/purchase/purchaseFillInfoPage.vue')
let purchaseComplete = () => import('../pages/myProperties/application/purchase/mobile/purchaseComplete.vue')
let purchaseVerify = () => import('../pages/myProperties/application/purchase/purchaseVerify.vue')
let append = () => import('../pages/myProperties/application/append/append.vue')
let appendConfirmInfo = () => import('../pages/myProperties/application/append/mobile/appendConfirmInfo.vue')
let appendConfirmInfoWeb = ()=> import('../pages/myProperties/application/append/web/appendConfirmInfoWeb')
let appendFillInfo = () => import('../pages/myProperties/application/append/appendFillInfoPage.vue')
let appendComplete = () => import('../pages/myProperties/application/append/mobile/appendComplete.vue')
let purchaseConfirmInfoWeb = () => import('../pages/myProperties/application/purchase/web/purchaseConfirmInfoWeb')
let purchaseFillInfoWeb = () => import('../pages/myProperties/application/purchase/web/purchaseFillInfoWeb')
let purchaseCompleteWeb = () => import('../pages/myProperties/application/purchase/web/purchaseCompleteWeb')
let confirmBasicInfoWeb = () => import('../pages/myProperties/application/confirmBasicInfoWeb')

let reports = () => import('../pages/mine/product-detail/reports.vue')
let reportsDetail = () => import('../pages/mine/product-detail/reportsDetail.vue')


let myAgreement = () => import('../pages/myProperties/myAgreement.vue')

//todo 产品资讯与公告页面 start
let MyLatestFundOrReportMessage = () => import('../pages/fundOrReportMessage/myLatestFundOrReportMessage')
let MyAllFundAndReportMessage = () => import('../pages/fundOrReportMessage/myAllFundAndReportMessage')
// 推介材料页面mobile
const fundIntroduction = () => import('../pages/mine/productDetail/fundIntroductionMobile.vue')
// 推介材料页面web
const fundIntroductionWeb = () => import('../pages/mine/productDetail/fundIntroductionWeb.vue')
let ImageVideoMp3View = (resolve) => {
  return require.ensure([], () => {
    resolve(require('../pages/fundOrReportMessage/ImageVideoMp3View'))
  }, 'ImageVideoMp3View')
}
const DirectImageVideoMp3View = (resolve) => {
  return require.ensure([], () => {
    resolve(require('../pages/fundOrReportMessage/directImageVideoMp3View'))
  }, 'DirectImageVideoMp3View')
}  // todo 信息推送 音视频资讯预览
const DirectPdfView = (resolve) => {
  return require.ensure([], () => {
    resolve(require('../pages/fundOrReportMessage/directPdfView'))
  }, 'DirectPdfView')
}  // todo 信息推送 pdf资讯预览

//todo 产品资讯与公告页面 end

const WechatFollowed = () => import('../pages/WechatFollowed')

let MRQIndex = () => import('@/pages/managerRiskQuestion/index')
let MRQClientLogin = () => import('@/pages/managerRiskQuestion/clientLogin')
let MRQSuitabilityQuestion = () => import('@/pages/managerRiskQuestion/suitabilityQuestion')
let MRQOfTypeQuestion = () => import('@/pages/managerRiskQuestion/ofTypeQuestion')
let MRQResult = () => import('@/pages/managerRiskQuestion/result')

let potentialConfirmIndex = () => import('@/pages/potentialConfirm/index')
let personFillCustomerInfo = () => import('@/pages/potentialConfirm/personFillCustomerInfo.vue')
let institutionFillAgentInfo = () => import('@/pages/potentialConfirm/institutionFillAgentInfo.vue')
let potentialConfirmPage = () => import('@/pages/potentialConfirm/potentialConfirmPage.vue')
let potentialSubmitSuccess = () => import('@/pages/potentialConfirm/submitSuccess.vue')

// 特定对象确认-高毅资产合格投资者确认书（PC/移动端共用同一套代码）
let qualifiedInvestor = () => import('@/pages/qualifiedInvestor/qualifiedInvestor.vue')

if (windowMatchMobile()) {
  myPropertiesTab = () => import('@/pages/newProperty/moveIndex.vue')
}

// 防止出现路由重复
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

let router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'is-active',
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  },
  routes: [
    //新增潜在客户确认书
    {
      path: '/potentialConfirm',
      component: potentialConfirmIndex,
      meta: {
        noWebNav: true,
      },
      children: [
        {
          path: '/personFillCustomerInfo',
          component: personFillCustomerInfo,
        },
        {
          path: '/institutionFillAgentInfo',
          component: institutionFillAgentInfo,
        },
        {
          path: '/potentialConfirmPage',
          component: potentialConfirmPage,
        },
        {
          path: '/submitSuccess',
          component: potentialSubmitSuccess
        },
      ]
    },
    // 特定对象确认-高毅资产合格投资者确认书（PC/移动端共用，购买流程适当性问卷前置节点）
    {
      path: '/qualifiedInvestor',
      component: qualifiedInvestor,
      beforeEnter: requireAuth,
      meta: {
        title: 'qualifiedInvestor',
        navTitle: '合格投资者确认书',
        navWebTitle: '合格投资者确认书',
        weChatTitle: '高毅资产合格投资者确认书',
        noWebNav: true,
      }
    },
    // 新的公告 报告 产品资讯等------------
    {
      path: '/messageList',  // 公告 报告 产品
      // component: () => import('../pages/myProperties/message/messageView'),
      component: () => import('../pages/messageList/moveIndex'),
      beforeEnter: requireAuth,
      meta: {
        noWebNav: true,
        parentTitle: [{name: '我的资产', path: '/myPropertiesTab'}],
        navWebTitle: '公告',
        goBack: '/myProperties'
      },
    },
    {
      path: '/noticeList',  // 公告 
      component: () => import('../pages/myProperties/message/messageView'),
      beforeEnter: requireAuth,
      meta: {
        parentTitle: [{name: '我的资产', path: '/myPropertiesTab'}],
        navWebTitle: '公告',
        goBack: '/myProperties'
      },
    },
    {
      path: '/reportList',  // 报告
      component: () => import('../pages/myProperties/message/messageView'),
      beforeEnter: requireAuth,
      meta: {
        parentTitle: [{name: '我的资产', path: '/myPropertiesTab'}],
        navWebTitle: '报告',
        goBack: '/myProperties'
      },
    },
    {
      path: '/productInformationList',  // 产品资讯
      component: () => import('../pages/myProperties/message/messageView'),
      beforeEnter: requireAuth,
      meta: {
        parentTitle: [{name: '我的资产', path: '/myPropertiesTab'}],
        navWebTitle: '产品资讯',
        goBack: '/myProperties'
      },
    },
    {
      path: '/audioAndVideo',
      name:"audioAndVideo",
      component: ImageVideoMp3View,
      beforeEnter: requireAuth,
      meta: {
        parentTitle: [
          {name: '我的资产', path: '/myPropertiesTab'},
          {name: '产品资讯', path: '/productInformationList'},
        ],
        toParentTitle: 'goBack',
      },
    },
    {
      path: '/noticePdf',
      component: pdfView,
      beforeEnter: requireAuth,
      meta: {
        parentTitle: [{name: '我的资产', path: '/myPropertiesTab'}, {name: '公告', path: '/noticeList'}],
        noWebNav: true,
        keepAlive: false
      },
    },
    {
      path: '/iframe-url',
      component: () => import('../pages/iframe-url.vue'),
      beforeEnter: requireAuth,
      meta: {
      },
    },
    {
      path: '/reportPdf',
      component: pdfView,
      beforeEnter: requireAuth,
      meta: {
        parentTitle: [{name: '我的资产', path: '/myPropertiesTab'}, {name: '报告', path: '/reportList'}],
        noWebNav: true,
        keepAlive: false
      },
    },
    {
      path: '/productInformationPdf',
      component: pdfView,
      beforeEnter: requireAuth,
      meta: {
        parentTitle: [{name: '我的资产', path: '/myPropertiesTab'}, {name: '产品资讯', path: '/productInformationList'}],
        noWebNav: true,
        keepAlive: false
      },
    },
    {
      path: '/noticeHistoryPdf',
      component: pdfView,
      beforeEnter: requireAuth,
      meta: {
        parentTitle: [ {name: '公告', path: '/noticeHistoryList'}],
        noWebNav: true,
        keepAlive: false
      },
    },
    {
      path: '/reportHistoryPdf',
      component: pdfView,
      beforeEnter: requireAuth,
      meta: {
        parentTitle: [{name: '报告', path: '/reportHistoryList'}],
        noWebNav: true,
        keepAlive: false
      },
    },
    {
      path: '/audioAndVideoHistory',
      name:"audioAndVideoHistory",
      component: ImageVideoMp3View,
      beforeEnter: requireAuth,
      meta: {
        parentTitle: [
          {name: '产品资讯', path: '/productInformationHistoryList'},
        ],
        toParentTitle: 'goBack',
      },
    },
    {
      path: '/productInformationHistoryPdf',
      name:'productInformationHistoryPdf',
      component: pdfView,
      meta: {
        parentTitle: [
          {name: '产品资讯', path: '/productInformationHistoryList'},
        ],
        toParentTitle: 'goBack',
        keepAlive: false,
      },
      beforeEnter: requireAuth
    },
    
    {
      path: '/historyList',  // 手机端全部公告、报告列表页
      component: () => import('../pages/myProperties/message/historyNoticeAndReportList'),
      beforeEnter: requireAuth,
      meta: {
        noWebNav: true,
      },
    },
    {
      path: '/noticeHistoryList',  // pc全部公告列表页
      component: () => import('../pages/myProperties/message/historyNoticeAndReportList'),
      beforeEnter: requireAuth,
      meta: {
        title: 'noticeHistoryList',
        navWebTitle: '公告',
        navTitle: '公告',
        keepAlive: false,
        // noBack: true
      },
    },
    {
      path: '/reportHistoryList',  // 全部报告列表页
      component: () => import('../pages/myProperties/message/historyNoticeAndReportList'),
      beforeEnter: requireAuth,
      meta: {
        title: 'reportHistoryList',
        navWebTitle: '报告',
        navTitle: '报告',
        keepAlive: false,
        // noBack: true
      },
    },
    {
      path: '/productInformationHistoryList',  // 产品资讯
      component: () => import('../pages/myProperties/message/historyNoticeAndReportList'),
      beforeEnter: requireAuth,
      meta: {
        title: 'productInformationHistoryList',
        navWebTitle: '产品资讯',
        navTitle: '产品资讯',
        keepAlive: false,
      },
    },
    {
      path: '/historyDetail',
      name:"historyDetail",
      component: () => import('../pages/myProperties/message/historyDetail'),
      meta: {
        noWebNav: true,
        goBack: '/messageList'
      },
      beforeEnter: requireAuth
    },
    // 沙龙问卷  start--------------------------------------
    {
      path: '/managerRiskQuestion',
      component: MRQIndex,
      meta: {
        noWebNav: true,
      },
      children: [
        {
          path: '/',
          component: MRQClientLogin,
          //name:"沙龙个人信息登录",
          meta: {
            noWebNav: true,
            noBack: true
          },
        },
        {
          path: '/managerRiskQuestion/suitability',
          component: MRQSuitabilityQuestion,
          //name:"沙龙 适当性问卷1",
          meta: {
            noWebNav: true,
          },
        },
        {
          path: '/managerRiskQuestion/ofType',
          component: MRQOfTypeQuestion,
          //name:"沙龙 测评问卷2",
          meta: {
            noWebNav: true,
          },
        },
        {
          path: '/managerRiskQuestion/result',
          component: MRQResult,
          //name:"沙龙 测评结果",
          meta: {
            noWebNav: true,
            noBack: true
          },
        },
        {
          path: '/managerRiskQuestion/resultComplete',
          component: MRQResult,
          //name:"沙龙 测评结果",
          meta: {
            noWebNav: true,
          },
        },
      ]
    },
    // 沙龙问卷  end
    {
      path: '/pdf',
      component: pdfView,
      meta: {
        toParentTitle: 'goBack',
        noWebNav: true,
      },
    },
    {
      path: '/pdfWeb',
      component: pdfView,
      meta: {
        parentTitle: [{name: '我的资产', path: '/myPropertiesTab'},{name: '', path: ''}],
        toParentTitle: 'goBack',
        noWebNav: true,
      },
      beforeEnter: requireAuth
    },
    // 双录前的电子合同
    {
      path: '/pdfRecord',
      component: () => import('@/pages/pdfRecord.vue'),
      meta: {
        webTracingName: '双录阅读合同',
        clearRollback: '/application-detail',
        weChatTitle: '阅读合同',
        noWebNav: true,
      },
    },
    //  预约状态
    {
      path: '/reservationSuccess',
      component: () => import('@/pages/eContract/reservationSuccess.vue'),
      beforeEnter: requireAuth,
      meta: {
        clearRollback: '/application-detail',
        noWebNav: true,
      },
    },
    {
      path: '/contractPreview',
      component: () => import('@/pages/eContract/components/contract-preview.vue'),
      meta: {
        noWebNav: true,
      },
    },
    {
      path: '/allReport',
      component: pdfView,
      beforeEnter: requireAuth,
      meta: {
        parentTitle: [{name: '公告报告', path: '/reports'}],
        noWebNav: true,
      },
    },
    {
      path: '/shareConfirmPdf',
      component: pdfView,
      beforeEnter: requireAuth,
      meta: {
        noWebNav: true,
        parentTitle: [{name: '我的预约', path: '/on-passage-application'},{name : '历史预约',path: '/history-application'}]
      },
    },
    {
      path: '/ePdf',
      component: pdfView,
      beforeEnter: requireAuth,
      meta: {
        navWebTitle: '合同',
        noWebNav: true,
        parentTitle: [{name: '产品详情', path: '/myAttentionTab'},{name: '', path: ''}],
      }
    },
    {
      path: '/contractFile',
      component: () => import('@/pages/contractFile/index.vue'),
      beforeEnter: requireAuth,
      meta: {
        navWebTitle: '合同文件',
        noWebNav: true,
        parentTitle: [{name: '产品详情', path: '/myAttentionTab'},{name: '', path: ''}],
      }
    },
    {
      path: '/fundIntroduction',
      component: fundIntroduction,
      beforeEnter: requireAuth,
      meta: {
        webTracingData: {
          eventId: 'recommentdations',
          title: '推介材料',
        },
        navWebTitle: '推介材料',
        noWebNav: true,
        parentTitle: [{name: '产品详情', path: '/myAttentionTab'},{name: '', path: ''}],
      }
    },
    {
      path: '/fundIntroductionWeb',
      component: fundIntroductionWeb,
      beforeEnter: requireAuth,
      meta: {
        navWebTitle: '推介材料',
        webTracingData: {
          eventId: 'recommentdations',
          title: '推介材料',
        },
        noWebNav: true,
        parentTitle: [{name: '产品详情', path: '/myAttentionTab'},{name: '', path: ''}],
      }
    },
    {
      path: '', // myProperties 默认容错口
      redirect: '/myProperties'
    },
    // {
    //   path: '*', // myProperties 默认容错口
    //   redirect: '/myProperties'
    // },
    {
      path: '/login',
      component: login,
      meta: {
        title: 'login',
        navWebTitle: '登录',
        navTitle: '登录',
        noWebNav: true,
        noBack: true
      }
    },
    {
      path: '/wechat',
      component: wechat
    },
    {
      path: '/wechat/redirect',
      component: wechatRedirect,
      beforeEnter: setRedirectPath,
      meta: {
        noBack: true
      }
    },
    {
      path: '/wechat/confirm',
      alias: '/wechatConfirm',
      component: wechatConfirm,
      meta: {
        goBack: '/login'
      }
    },
    {
      path: '/agreementPage',
      component: agreementPage,
      beforeEnter: requireAuth,
      meta: {
        noBack: true,
        noWebNav: true
      }
    },
    {
      path: '/agreementDialogPage',
      component: agreementDialogPage,
      beforeEnter: requireAuth,
      meta: {
        noBack: true
      }
    },
    {
      path: '/login/bytoken',
      component: tokenRedirect,
      meta: {
        noBack: true
      }
    },
    {
      path: '/riskEvaluation',
      component: riskEvaluation,
      meta: {
        title: 'riskEvaluation',
        navWebTitle: '风险评估',
        navTitle: '风险评估',
        noBack: true
      },
      beforeEnter: requireAuth
    },
    {
      path: '/fillInfo',
      component: fillInfo,
      meta: {
        title: 'fillInfo',
        navWebTitle: '填写信息',
        navTitle: '填写信息'
      },
      beforeEnter: requireAuth
    },
    {
      path: '/mobileRiskRemind',
      component: mobileRiskRemind,
      meta: {
        title: 'riskRemind',
        navWebTitle: '风险揭示书',
        navTitle: '风险揭示书'
      },
      beforeEnter: requireAuth
    },
    {
      path: '/mobileInvestorResult',
      component: investorResult,
      beforeEnter: requireAuth
    },
    {
      path: '/mobileQuestionnaire',
      component: mobileQuestionnaire,
      beforeEnter: requireAuth
    },
    {
      path: '/questionnaireResult',
      component: questionnaireResult,
      beforeEnter: requireAuth
    },
    {
      path: '/mobileRiskInvestor',
      component: mobileRiskInvestor,
      beforeEnter: requireAuth
    },
    {
      path: '/propertyDetailsMobile',
      component: propertyDetailsMobile,
      beforeEnter: requireAuth
    },
    {
      path: '/productDetail',
      component: ProductDetail,
      meta: {
        title: 'productDetail',
        navWebTitle: '产品详情',
        parentTitle: [{name: '我的资产', path: '/myPropertiesTab'}],
        navTitle: '产品详情',
        noWebNav: true,
        appoint_id: '',
        goBack: '/myProperties?i=?'
      },
      beforeEnter: requireAuth,
      children: [
        {
          path: ':appoint_id?',
          component: productElements,
          name: 'productDetail', // 'productElements',
          meta: {
            noWebNav: true,
            webTracingData: {
              eventId: 'productFactors',
              title: '产品要素',
            },
            title: 'productElements',
            parentTitle: [{name: '产品信息', path: '/myAttentionTab'}],
            navWebTitle: '产品详情', // '产品要素',
            navTitle: '产品要素'
          },
          beforeEnter: requireAuth
        },
        {
          path: '/productReports/:appoint_id?',
          component: productReports,
          name: 'productReports',
          meta: {
            title: 'productReports',
            noWebNav: true,
            parentTitle: [{name: '我的资产', path: '/myPropertiesTab'}],
            navWebTitle: '公告报告',
            navTitle: '公告报告',
            goBack: '/myProperties?i=?'
          },
          beforeEnter: requireAuth
        },
        {
          path: '/productDetails/:appoint_id?',
          component: productDetails,
          name: 'productDetails',
          meta: {
            title: 'productDetails',
            parentTitle: '我的资产',
            navWebTitle: '产品详情',
            noWebNav: true,
            goBack: '/myProperties?i=?',
            navTitle: '产品详情'
            // goBack: '/myProperties?i=?'
          },
          beforeEnter: requireAuth
        }
      ]
    },
    {
      path: '/addFund',
      component: addFund,
      meta: {
        title: 'addFund',
        navWebTitle: '追加申购',
        navTitle: '追加申购',
        goBack: '/propertyDetails'
      },
      beforeEnter: requireAuth
    },
    {
      path: '/purchaseStatusWait',
      component: purchaseStatusWait,
      meta: {
        title: 'purchase',
        navWebTitle: '提交申购申请',
        navTitle: '提交申购申请'
      },
      beforeEnter: requireAuth
    },
    {
      path: '/register',
      component: Register,
      meta: {
        goBack: '/login'
      },
      children: [
        {
          path: '/registMobileOne',
          component: registMobileOne,
          meta: {
            goBack: '/login',
            noWebNav: true
          }
        },
        {
          path: '/registMobileTwo',
          component: registMobileTwo,
        },
        {
          path: '/registMobileThree',
          component: registMobileThree,
        }
      ]
    },
    {
      path: '/findPassword',
      component: findPassword,
      name: 'findPassword',
      meta: {
        title: 'findPassword',
        navWebTitle: '找回密码',
        noWebNav: true,
        navTitle: '找回密码',
      },
      children: [
        {
          path: '',
          alias: '/findPasswordOne',
          component: findPasswordOne,
          meta: {
            title: 'findPasswordOne',
            noWebNav: true,
            navTitle: '找回密码',
            navWebTitle: '找回密码',
            webTracingData: {
              eventId: 'findPassword',
              title: '找回密码',
            },
          }
        },
        {
          path: '/findPasswordTwo',
          component: findPasswordTwo,
          meta: {
            title: 'findPasswordTwo',
            noWebNav: true,
            navWebTitle: '找回密码',
            navTitle: '找回密码'
          }
        },
        {
          path: '/findPasswordThree',
          component: findPasswordThree,
          meta: {
            title: 'findPasswordThree',
            noWebNav: true,
            navWebTitle: '找回密码',
            navTitle: '找回密码'
          }
        },
        {
          path: '/findPasswordFour',
          component: findPasswordFour,
          meta: {
            title: 'findPasswordFour',
            noWebNav: true,
            navWebTitle: '找回密码',
            navTitle: '找回密码',
            noBack: true
          }
        },
        {
          path: '/findPasswordAgreement',
          component: findPasswordAgreement,
          meta: {
            title: 'findPasswordAgreement',
            navWebTitle: '高毅注册协议',
            navTitle: '高毅注册协议'
          }
        }
      ]
    },
    {
      path: '/historyTab/:i?',
      component: HistoryTabRoute,
      name: 'historyTab',
      beforeEnter: requireAuth,
      meta: {
        webTracingData: {
          eventId: 'tradeHistory',
          title: '交易记录列表',
        },
        isUseCache: false,
        keepAlive: true,
        navWebTitle: '交易记录'
      }
    },
    {
      path: '/historyTabNoBack',
      component: HistoryTabRoute,
      beforeEnter: requireAuth,
      meta: {
        noBack: true
      }
    },
    {
      path: '/myProperties',
      component: myProperties,
      name: 'myProperties',
      meta: {
        webTracingData: {
          eventId: 'myProperties',
          title: '我的资产',
        },
        title: 'myProperties',
        navTitle: '',
        navWebTitle: '我的资产',
        rightIcon: true,
        noBack: true
      },
      beforeEnter: requireAuth,
      children: [{
        path: '/myPropertiesTab/:i?',
        component: myPropertiesTab,
        name: 'myPropertiesTab',
        alias: '/myProperties',
        meta: {
          webTracingData: {
            eventId: 'myProperties',
            title: '我的资产',
          },
          title: 'myPropertiesTab',
          navTitle: '',
          navWebTitle: '我的资产',
          rightIcon: true,
          noBack: true
        },
        beforeEnter: requireAuth
      },
      // 扫码双录，扫码后跳转到我的资产页
      {
        path: '/directMyPropertiesTab',
        name: 'directMyPropertiesTab',
        component: directMyPropertiesTab,
        meta: {
          title: 'directMyPropertiesTab',
          navTitle: '',
          navWebTitle: '我的资产',
          rightIcon: true,
          noBack: true
        },
      },
        {
          path: '/myAttentionTab/:i?',
          component: MyAttentionTab,
          name: 'myAttentionTab',
          meta: {
            webTracingData: {
              eventId: 'productList',
              title: '产品列表',
            },
            title: 'myAttentionTab',
            navTitle: '',
            navWebTitle: '产品信息',
            rightIcon: true,
            noBack: true
          },
          beforeEnter: requireAuth
        },
        {
          path: '/personalData',
          component: personalData,
          meta: {
            webTracingData: {
              eventId: 'myInfos',
              title: '我的',
            },
            title: 'personalData',
            navTitle: '个人资料',
            navWebTitle: '个人资料',
            rightIcon: false,
            noBack: true
          },
          beforeEnter: requireAuth
        }
      ]
    },
    {
      path: '/personalInfo',
      component: personalInfo,
      meta: {
        webTracingName: '个人资料',
        goBack: '/personalData'
      },
      beforeEnter: requireAuth
    },
    {
      path: '/passwordAll',
      component: passwordAll,
      meta: {
        webTracingData: {
          eventId: 'passwordConfig',
          title: '安全设置',
        },
      },
      beforeEnter: requireAuth
    },
    {
      path: '/signModify',
      component: () => import('@/pages/myProperties/password/signModify.vue'),
      meta: {
        webTracingData: {
          eventId: 'changeSignPassword',
          title: '验证签署密码',
        },
      },
      beforeEnter: requireAuth
    },
    {
      path: '/signModifyTwo',
      component: () => import('@/pages/myProperties/password/signModifyTwo.vue'),
      meta: {
        webTracingData: {
          eventId: 'changeSignPasswordTwo',
          title: '修改签署密码',
        },
      },
      beforeEnter: requireAuth
    },
    {
      path: '/signRetrieve',
      component: () => import('@/pages/myProperties/password/signRetrieve.vue'),
      meta: {
        webTracingData: {
          eventId: 'resetSignPassword',
          title: '找回签署密码',
        },
      },
      beforeEnter: requireAuth
    },
    {
      path: '/changePasswordOne',
      component: changePasswordOne,
      meta: {
        webTracingData: {
          eventId: 'changePassword',
          title: '修改密码',
        },
      },
      beforeEnter: requireAuth
    },
    {
      path: '/changePasswordTwo',
      component: changePasswordTwo,
      beforeEnter: requireAuth
    },
    {
      path: '/changeEmail',
      component: changeEmail,
      beforeEnter: requireAuth,
      meta: {
        navWebTitle: '修改邮箱',
        parentTitle: [{name: '个人资料', path: '/personalData'}]
      }
    },
    {
      path: '/changeAddress',
      component: changeAddress,
      beforeEnter: requireAuth,
      meta: {
        navWebTitle: '修改联系地址',
        parentTitle: [{name: '个人资料', path: '/personalData'}]
      }
    },
    {
      path: '/propertyDetails',
      component: PropertyDetails,
      meta: {
        webTracingData: {
          eventId: 'productInfo',
          title: '资产详情',
        },
        title: 'propertyDetails',
        noWebNav: true,
        parentTitle: [{name: '我的资产', path: '/myPropertiesTab'}],
        parentPath: '/myPropertiesTab',
        goBack: '/myPropertiesTab?i=0'
      },
      beforeEnter: requireAuth
    },
    {
      path: '/historyDetails',
      component: historyDetails,
      name: 'historyDetails',
      meta: {
        webTracingData: {
          eventId: 'tradeDetail',
          title: '交易记录详情',
        },
        title: 'historyDetails',
        navWebTitle: '交易记录明细',
        navTitle: '交易记录明细',
        parentTitle: [{name: '交易记录', path: '/historyTab'}]
      },
      beforeEnter: requireAuth
    },
    {
      path: '/on-passage-application',
      component: onPassageApplication,
      beforeEnter: requireAuth,
      meta:{
        webTracingData: {
          eventId: 'processingOrder',
          title: '进行中的预约',
        },
        goBack: '/personalData',
        navWebTitle: '我的预约'
      }
    },
    {
      path: '/history-application',
      component: historyApplication,
      beforeEnter: requireAuth,
      meta: {
        webTracingData: {
          eventId: 'orderHistory',
          title: '历史预约列表',
        },
        navWebTitle: '历史预约',
        parentTitle: [{name: '我的预约', path: '/on-passage-application'},{name: '',path: ''}]
      }
    },
    {
      path: '/application-detail',
      component: applicationDetail,
      beforeEnter: requireAuth,
      meta: {
        weChatTitle: '预约详情',
        webTracingData: {
          eventId: 'orderDetail',
          title: '预约详情',
        },
      }
    },
    {
      path: '/application-detail_web',
      component: applicationDetailWeb,
      beforeEnter: requireAuth,
      meta: {
        webTracingData: {
          eventId: 'orderDetail',
          title: '预约详情',
        },
        navWebTitle: '预约详情',
        parentTitle: [{name: '我的预约', path: '/on-passage-application'},{name: '', path: ''}]
      }
    },
    {
      path: '/waitingForAsync',
      component: waitingForAsync
    },
    {
      path: '/historyAsset',
      component: historyAsset,
      meta: {
        webTracingData: {
          eventId: 'historyEvaluation',
          title: '历史持仓',
        },
        navWebTitle: '历史查询',
        parentTitle: [{name: '我的资产', path: '/myPropertiesTab'}]
      },
      beforeEnter: requireAuth
    },
    {
      path: '/historyNav',
      component: historyNav,
      meta: {
        webTracingData: {
          eventId: 'historyNav',
          title: '历史净值',
        },
        // navWebTitle: '历史净值'
      },
      beforeEnter: requireAuth
    },
    {
      path: '/report',
      meta: {
        webTracingData: {
          eventId: 'singleProductAnnouncementAndReport',
          title: '单个产品的公告报告列表',
        },
      },
      component: productReports,
      beforeEnter: requireAuth
    },
    {
      path: '/redeem',
      component: redeem,
      beforeEnter: requireAuth,
      children: [
        {
          path: '/redeemFillInfo',
          component: redeemFillInfo,
          beforeEnter: requireAuth,
          meta: {
            navWebTitle: '赎回',
            webTracingName: '赎回-填写预约信息',
            parentTitle: [{name: '我的资产', path: '/myPropertiesTab'}]
          }
        },
        {
          name: 'redeemVerify',
          path: '/redeemVerify',
          component: redeemVerify,
          meta: {
            navWebTitle: '赎回',
            parentTitle: [{name: '我的资产', path: '/myPropertiesTab'}]
          },
          beforeEnter: requireAuth
        },
        {
          path: '/redeemComplete',
          component: redeemComplete,
          meta: {
            navWebTitle: '赎回',
            parentTitle: [{name: '我的资产', path: '/myPropertiesTab'}]
          },
          beforeEnter: requireAuth
        },
      ]
    },
    {
      path: '/cancellation',
      name: 'cancellation',
      component: cancellation,
      beforeEnter: requireAuth,
      children: [
        {
          path: '/cancellationVerify',
          name: 'cancellationVerify',
          component: cancellationVerify,
          beforeEnter: requireAuth,
          meta: {
            parentTitle: [{name: '我的预约', path: '/on-passage-application'}]
          }
        },
        {
          path: '/cancellationComplete',
          name: 'cancellationComplete',
          component: cancellationComplete,
          beforeEnter: requireAuth,
          meta:{
            parentTitle: [{name: '我的预约', path: '/on-passage-application'}]
          }
        }
      ]
    },
    {
      path: '/amend',
      name: 'amend',
      component: amend,
      beforeEnter: requireAuth,
      children: [
        {
          path: '/amendVerify',
          name: 'amendVerify',
          component: amendVerify,
          beforeEnter: requireAuth
        },
        {
          path: '/amendFillInfo',
          name: 'amendFillInfo',
          component: amendFillInfo,
          beforeEnter: requireAuth
        },
        {
          path: '/amendComplete',
          name: 'amendComplete',
          component: amendComplete,
          beforeEnter: requireAuth
        }

      ]
    },
    {
      path: '/purchase',
      name: 'purchase',
      component: purchase,
      beforeEnter: requireAuth,
      meta: {
        keepAlive: true,
        navWebTitle: '申购',
      },
      children: [
        {
          path: '/purchaseConfirmInfo',
          name: 'purchaseConfirmInfo',
          component: purchaseConfirmInfo,
          beforeEnter: requireAuth,
          meta: {
            webTracingName: '认申购-确认个人信息',
          }
        },
        {
          path: '/purchaseFillInfo',
          name: 'purchaseFillInfo',
          component: purchaseFillInfo,
          meta: {
            webTracingName: '认申购-填写预约信息',
            parentTitle: [{name: '产品信息', path: '/myAttentionTab'}]
          },
          beforeEnter: requireAuth
        },
        {
          path: '/subscribeFillInfo',
          name: 'subscribeFillInfo',
          component: purchaseFillInfo,
          meta: {
            navWebTitle: '认购',
            parentTitle: [{name: '产品信息', path: '/myAttentionTab'}]
          },
          beforeEnter: requireAuth
        },
        {
          path: '/subscribeConfirmFillInfo',
          name: 'subscribeConfirmFillInfo',
          component: purchaseConfirmInfoWeb,
          meta: {
            navWebTitle: '认购',
            parentTitle: [{name: '产品信息', path: '/myAttentionTab'}]
          },
          beforeEnter: requireAuth
        },
        {
          path: '/subscribeVerify',
          name: 'subscribeVerify',//认购身份认证页
          component: purchaseVerify,
          meta: {
            navWebTitle: '认购',
            parentTitle: [{name: '产品信息', path: '/myAttentionTab'}]
          },
          beforeEnter: requireAuth
        },
        {
          path: '/purchaseComplete',
          name: 'purchaseComplete',
          component: purchaseComplete,
          meta: {
            clearRollback: '/application-detail',
            navWebTitle: '提交申购预约',
            parentTitle: [{name: '产品信息', path: '/myAttentionTab'}]
          },
          beforeEnter: requireAuth
        },
        {
          path: '/subscribeComplete',
          name: 'subscribeComplete',
          component: purchaseComplete,
          meta: {
            clearRollback: '/application-detail',
            navWebTitle: '提交认购预约',
            parentTitle: [{name: '产品信息', path: '/myAttentionTab'}]
          },
          beforeEnter: requireAuth
        },
        {
          path: '/purchaseFillInfoWeb',
          name: 'purchaseFillInfoWeb',
          component: purchaseFillInfoWeb,
          beforeEnter: requireAuth
        },
        {
          path: '/purchaseConfirmInfoWeb',
          name: 'purchaseConfirmInfoWeb',
          component: purchaseConfirmInfoWeb,
          meta: {
            navWebTitle: '申购',
            parentTitle: [{name: '产品信息', path: '/myAttentionTab'}]
          },
          beforeEnter: requireAuth
        },
        {
          path: '/purchaseVerify',
          name: 'purchaseVerify',//申购身份认证页
          component: purchaseVerify,
          meta: {
            navWebTitle: '申购',
            parentTitle: [{name: '产品信息', path: '/myAttentionTab'}]
          },
          beforeEnter: requireAuth
        },
        {
          path: '/purchaseCompleteWeb',
          name: 'purchaseCompletebWeb',
          component: purchaseCompleteWeb,
          beforeEnter: requireAuth
        },
        {
          path: '/identityVerification', // 身份验证选择页
          name: 'identityVerification',
          component: () => import('@/pages/eContract/identityVerification/identityVerification.vue'),
          beforeEnter: requireAuth,
          meta: {
            webTracingName: '验证身份信息',
            weChatTitle: '验证身份信息',
          },
        },
        {
          path: '/setSignature',
          component: () => import('@/pages/eContract/signature/setSignature.vue'),
          beforeEnter: requireAuth,
          meta: {
            webTracingName: '设置签名图案和密码',
            clearRollback: '/application-detail',
            weChatTitle: '设置电子签名',
            noWebNav: true,
          },
        },
        // 上传资质证明文件
        {
          path: '/uploadFile',
          name: 'uploadFile',
          component: () => import('@/pages/eContract/uploadFile/uploadFile.vue'),
          beforeEnter: requireAuth,
          meta: {
            clearRollback: '/application-detail',
            webTracingName: '上传资质证明文件',
            weChatTitle: '上传资质证明文件',
            noWebNav: true,
            keepAlive: true,
          },
        },
        // 电子合同详情----打款
        {
          path: '/makePayment',
          component: () => import('@/pages/makePayment/index.vue'),
          beforeEnter: requireAuth,
          meta: {
            weChatTitle: '打款',
            webTracingName: '打款确定',
            toParentTitle: 'goBack',
            noWebNav: true,
            goBack: false
          },
        },
        // 电子合同详情----回访确定
        {
          path: '/returnVisit',
          component: () => import('@/pages/returnVisit/index.vue'),
          beforeEnter: requireAuth,
          meta: {
            webTracingName: '回访确认',
            weChatTitle: '回访确认',
            toParentTitle: 'goBack',
            noWebNav: true,
            goBack: false
          },
        },
      ]
    },
    {
      path: '/append',
      name: 'append',
      component: append,
      beforeEnter: requireAuth,
      children: [
        {
          path: '/appendConfirmInfo',
          name: 'appendConfirmInfo',
          component: appendConfirmInfo,
          meta: {
            webTracingName: '追加-确认个人信息',
            navWebTitle: '追加',
            parentTitle: [{name: '我的资产', path: '/myPropertiesTab'}]
          },
          beforeEnter: requireAuth
        },
        {
          path: '/appendConfirmInfoWeb',
          name: 'appendConfirmInfoWeb',
          component: appendConfirmInfoWeb,
          meta: {
            navWebTitle: '追加',
            parentTitle: [{name: '我的资产', path: '/myPropertiesTab'}]
          }
        },
        {
          path: '/appendFillInfo',
          name: 'appendFillInfo',
          component: appendFillInfo,
          meta: {
            navWebTitle: '追加',
            webTracingName: '追加-填写预约信息',
            parentTitle: [{name: '我的资产', path: '/myPropertiesTab'}]
          },
          beforeEnter: requireAuth
        },
        {
          path: '/appendComplete',
          name: 'appendComplete',
          component: appendComplete,
          meta: {
            navWebTitle: '追加',
            parentTitle: [{name: '我的资产', path: '/myPropertiesTab'}]
          },
          beforeEnter: requireAuth
        },
        {
          path: '/appendConfirmInfoWeb',
          name: 'appendConfirmInfoWeb',
          component: appendConfirmInfoWeb,
          meta: {
            navWebTitle: '追加',
            parentTitle: [{name: '产品信息', path: '/myAttentionTab'}]
          }
        },
        {
          name: 'appendVerify',
          path: '/appendVerify',
          component: appendVerify,
          meta: {
            navWebTitle: '追加',
            parentTitle: [{name: '我的资产', path: '/myPropertiesTab'}]
          },
          beforeEnter: requireAuth
        },
        {
          path: '/appendIdentityVerification', // 身份验证选择页
          name: 'appendIdentityVerification',
          component: () => import('../pages/eContract/identityVerification/identityVerification.vue'),
          beforeEnter: requireAuth,
          meta: {
            weChatTitle: '验证身份信息',
          },
        },
      ]
    },
    {
      path: '/editPassword',
      name: 'editPassword',
      component: editPassword,
      beforeEnter: requireAuth,
      meta: {
        navWebTitle: '修改密码',
        parentTitle: [{name: '个人资料', path: '/personalData'}]
      }
    },
    {
      path: '/findSignPassword',
      name: 'findSignPassword',
      component: () => import('@/pages/myProperties/findSignPassword.vue'),
      beforeEnter: requireAuth,
      meta: {
        navWebTitle: '找回文件签署密码',
        parentTitle: [{name: '个人资料', path: '/personalData'}]
      }
    },
    {
      path: '/editSignPassword',
      name: 'editSignPassword',
      component: () => import('@/pages/myProperties/editSignPassword.vue'),
      beforeEnter: requireAuth,
      meta: {
        navWebTitle: '修改文件签署密码',
        parentTitle: [{name: '个人资料', path: '/personalData'}]
      }
    },
    {
      path: '/basicInformation',
      name: 'basicInformation',
      component: () => import('@/pages/myProperties/basicInformation.vue'),
      beforeEnter: requireAuth,
      meta: {
        navWebTitle: '投资者基本信息表',
        parentTitle: [{name: '个人资料', path: '/personalData'}]
      }
    },
    {
      path: '/confirmBasicInfoWeb',
      name: 'confirmBasicInfoWeb',
      component: confirmBasicInfoWeb,
      beforeEnter: requireAuth
    },
    {
      path: '/quicklyRegister',
      component: quicklyRegister,
      meta: {
        title: 'quicklyRegister',
        navWebTitle: '一键注册',
        navTitle: '一键注册'
      }
    },
    {
      path: '/myAgreement',
      component: myAgreement,
      meta: {
        webTracingData: {
          eventId: 'readAgreement',
          title: '查看协议',
        },
        title: 'myAgreement',
        navWebTitle: '高毅资产服务平台使用协议',
        navTitle: '高毅资产服务平台使用协议'
      },
	  beforeEnter: requireAuth
    },
    {
      path: '/reports',
      component: reports,
      meta: {
        title: 'reports',
        navWebTitle: '公告与报告',
        navTitle: '公告与报告',
        goBack: '/myProperties'
        // noBack: true
      },
      beforeEnter: requireAuth
    },
    {
      path: '/reportsNoBack',
      component: reports,
      meta: {
        webTracingData: {
          eventId: 'reportsFromMenu',
          title: '从菜单进入公告报告',
        },
        title: 'reports',
        navWebTitle: '公告报告',
        navTitle: '公告报告',
        goBack: '/myProperties',
        noBack: true
      },
      beforeEnter: requireAuth
    },
    {
      path: '/reportsNoBackDetail',
      name:"reportsNoBackDetail",
      component: reportsDetail,
      meta: {
        title: 'reportsDetail',
        navWebTitle: '公告报告',
        navTitle: '公告报告',
        goBack: '/reportsNoBack',
        noBack: false
      },
      beforeEnter: requireAuth
    },
    {
      path: '/myLatestFundOrReportMessage',
      name:"myLatestFundOrReportMessage",
      component: MyLatestFundOrReportMessage,
      meta: {
        navWebTitle: '产品资讯与报告',
        parentTitle: [{name: '我的资产', path: '/myPropertiesTab'}],
        keepAlive: true,
      },
      beforeEnter: requireAuth
    },
    {
      path: '/myAllReportMessage',
      name:"myAllReportMessage",
      component: reports,
      meta: {
        navWebTitle: '公告与报告',
        parentTitle: [
          {name: '我的资产', path: '/myPropertiesTab'},
          {name: '产品资讯与报告', path: '/myLatestFundOrReportMessage'},
        ]
      },
      beforeEnter: requireAuth
    },
    {
      path: '/myAllReportMsgReportsDetail',
      name:"myAllReportMsgReportsDetail",
      component: reportsDetail,
      meta: {
        title: 'reportsDetail',
        navWebTitle: '公告报告',
        navTitle: '公告报告'
      },
      beforeEnter: requireAuth
    },
    {
      path: '/myAllFundAndReportMessage',
      component: MyAllFundAndReportMessage,
      name:"myAllFundAndReportMessage",
      meta: {
        title: 'myAllFundAndReportMessage',
        navWebTitle: '产品资讯',
        navTitle: '产品资讯',
        // goBack: '/myProperties',
        // noBack: true
      },
      beforeEnter: requireAuth
    },
    {
      path: '/myAllFundAndReportMessageNoBack',
      component:  () => import('../pages/myProperties/message/historyNoticeAndReportList'),
      name:"myAllFundAndReportMessageNoBack",
      meta: {
        title: 'myAllFundAndReportMessageNoBack',
        navWebTitle: '产品资讯',
        navTitle: '产品资讯',
        // goBack: '/myProperties',
        noBack: true
      },
      beforeEnter: requireAuth
    },
    {
      path: '/latestFundAndReportMsgPdfWeb',
      name:'latestFundAndReportMsgPdfWeb',
      component: pdfView,
      meta: {
        parentTitle: [
          {name: '我的资产', path: '/myPropertiesTab'},
          {name: '产品资讯与报告', path: '/myLatestFundOrReportMessage'},
          // {name: '', path: ''}
        ],
        toParentTitle: 'goBack',
        noWebNav: true,
      },
      beforeEnter: requireAuth
    },
    {
      path: '/fundAndReportMsgPdfWeb',
      name:'fundAndReportMsgPdfWeb',
      component: pdfView,
      meta: {
        parentTitle: [
          {name: '我的资产', path: '/myPropertiesTab'},
          {name: '产品资讯与报告', path: '/myLatestFundOrReportMessage'},
          {name: '产品资讯', path: '/myAllFundMessage'},
        ],
        toParentTitle: 'goBack',
      },
      beforeEnter: requireAuth
    },
    {
      path: '/fundAndReportMsgPdfWeb2',
      name:'fundAndReportMsgPdfWeb2',
      component: pdfView,
      meta: {
        parentTitle: [
          {name: '我的资产', path: '/myPropertiesTab'},
          {name: '产品资讯与报告', path: '/myLatestFundOrReportMessage'},
          {name: '公告报告', path: '/myAllReportMessage',query:{type:'reports'}},
          // {name: '', path: ''}
        ],
        toParentTitle: 'goBack',
      },
      beforeEnter: requireAuth
    },
    {
      path: '/fundAndReportMsgPdfWeb3',
      name:'fundAndReportMsgPdfWeb3',
      component: pdfView,
      meta: {
        parentTitle: [
          {name: '产品资讯', path: '/myAllFundAndReportMessage'},
        ],
        toParentTitle: 'goBack',
        noWebNav: true,
      },
      beforeEnter: requireAuth
    },
    {
      path: '/fundAndReportMsgPdfWeb4',
      name:'fundAndReportMsgPdfWeb4',
      component: pdfView,
      meta: {
        parentTitle: [
          {name: '我的资产', path: '/myPropertiesTab'},{name: '', path: ''}
        ],
        toParentTitle: 'goBack',
      },
      beforeEnter: requireAuth
    },
    {
      path: '/fundAndReportMsgPdfWeb5',
      name:'fundAndReportMsgPdfWeb5',
      component: pdfView,
      meta: {
        parentTitle: [
          {name: '产品信息', path: '/myAttentionTab'},{name: '', path: ''}
        ],
        toParentTitle: 'goBack',
      },
      beforeEnter: requireAuth
    },
    {
      path: '/directImageVideoMp3View',
      name:"directImageVideoMp3View",
      component: DirectImageVideoMp3View,
      meta: {
        noBack: true
      },
    },
    {
      path: '/wechatFollowed',
      name: "wechatFollowed",
      component: WechatFollowed,
    },
    {
      path: '/directFundAndReportMsgPdfWeb',
      name:'directFundAndReportMsgPdfWeb',
      component: DirectPdfView,
      meta: {
        noBack: true
      },
    },
    {
      path: '/imageVideoMp3View',
      name:"imageVideoMp3View",
      component: ImageVideoMp3View,
      beforeEnter: requireAuth,
      meta: {
        parentTitle: [
          {name: '我的资产', path: '/myPropertiesTab'},
          {name: '产品资讯与报告', path: '/myLatestFundOrReportMessage'},
        ],
        toParentTitle: 'goBack',
      },
    },
    {
      path: '/imageVideoMp3View2',
      name:"imageVideoMp3View2",
      component: ImageVideoMp3View,
      beforeEnter: requireAuth,
      meta: {
        parentTitle: [
          {name: '我的资产', path: '/myPropertiesTab'},
          {name: '产品资讯与报告', path: '/myLatestFundOrReportMessage'},
          {name: '产品资讯', path: '/myAllFundMessage'}
        ],
        toParentTitle: 'goBack',
      },
    },
    {
      path: '/imageVideoMp3View3',
      name:"imageVideoMp3View3",
      component: ImageVideoMp3View,
      beforeEnter: requireAuth,
      meta: {
        parentTitle: [
          {name: '产品资讯', path: '/myAllFundAndReportMessage'},
        ],
        toParentTitle: 'goBack',
      },
    },
    {
      path: '/imageVideoMp3View4',
      name:'imageVideoMp3View4',
      component: ImageVideoMp3View,
      meta: {
        parentTitle: [{name: '我的资产', path: '/myPropertiesTab'},{name: '', path: ''}],
        toParentTitle: 'goBack',
        noWebNav: true,
      },
      beforeEnter: requireAuth
    },
    {
      path: '/bankVerifyOne',
      name: 'bankVerifyOne',
      component: () => import('@/pages/eContract/identityVerification/bankVerifyOne.vue'),
      beforeEnter: requireAuth,
      meta: {
        webTracingName: '验证身份信息-银行卡认证',
        weChatTitle: '验证身份信息',
        toParentTitle: 'goBack',
        noWebNav: true,
      },
    },
    {
      path: '/bankVerifyTwo',
      component: () => import('@/pages/eContract/identityVerification/bankVerifyTwo.vue'),
      beforeEnter: requireAuth,
      meta: {
        webTracingName: '银行卡认证-验证身份信息-四要素',
        weChatTitle: '银行卡认证',
        toParentTitle: 'goBack',
        noWebNav: true,
      },
    },
    {
      path: '/bankVerifyFive',
      component: () => import('@/pages/eContract/identityVerification/bankVerifyFive.vue'),
      beforeEnter: requireAuth,
      meta: {
        webTracingName: '银行卡认证-验证身份信息-五要素',
        weChatTitle: '银行卡认证',
        toParentTitle: 'goBack',
        noWebNav: true,
      },
    },
    {
      path: '/faceVerifyOne',
      component: () => import('@/pages/eContract/identityVerification/faceVerifyOne.vue'),
      beforeEnter: requireAuth,
      meta: {
        webTracingName: '验证身份信息-人脸识别认证',
        weChatTitle: '验证身份信息',
        toParentTitle: 'goBack',
      },
    },
    // 签署电子签名承诺函
    {
      path: '/promisePdf',
      component: () => import('@/pages/eContract/signature/promisePdf.vue'),
      beforeEnter: requireAuth,
      meta: {
        clearRollback: '/application-detail',
        webTracingName: '签署电子签名承诺函',
        weChatTitle: '签署电子签名承诺函',
        noWebNav: true,
      },
    },
    // 忘记密码，重新确认签署
    {
      path: '/forgetPwd',
      component: () => import('@/pages/eContract/signature/forgetPwd.vue'),
      beforeEnter: requireAuth,
      meta: {
        webTracingName: '重新设置电子签名签署密码',
        weChatTitle: '重新设置电子签名签署密码',
        toParentTitle: 'goBack',
        noWebNav: true,
      },
    },
    // 认申购文件列表
    {
      path: '/purchaseFileList',
      component: () => import('@/pages/purchaseFileList/index.vue'),
      beforeEnter: requireAuth,
      meta: {
        webTracingName: '认/申购文件文件列表',
        weChatTitle: '认/申购文件',
        toParentTitle: 'goBack',
        noWebNav: true,
        goBack: false
      },
    },
    // 适当性文件一键签署页面
    {
      path: '/fileList',
      component: () => import('@/pages/eContract/uploadFile/fileList.vue'),
      beforeEnter: requireAuth,
      meta: {
        webTracingName: '签署适当性文件',
        weChatTitle: '签署适当性文件',
        toParentTitle: 'goBack',
        noWebNav: true,
      },
    },
    // 资质证明文件预览
    {
      path: '/assetsPdf',
      component: () => import('@/pages/eContract/uploadFile/assetsPdf.vue'),
      beforeEnter: requireAuth,
      meta: {
        weChatTitle: '上传资质证明文件',
        webTracingName: '认证上传资质证明文件',
        noWebNav: true,
      },
    },
    // 电子签名模块的协议阅读 手机端
    {
      path: '/readAgreement',
      component: () => import('@/pages/eContract/readAgreement.vue'),
      beforeEnter: requireAuth,
      meta: {
        toParentTitle: 'goBack',
        noWebNav: true,
        goBack: true
      },
    },
    // 预览PDF
    {
      path: '/previewPDF',
      component: () => import('@/pages/previewPDF/index.vue'),
      beforeEnter: requireAuth,
      meta: {
        toParentTitle: 'goBack',
        noWebNav: true,
      },
    },
    // pdfjs页面查看
    {
      path: '/pdfjs',
      component: () => import('@/pages/pdfjs.vue'),
      beforeEnter: requireAuth,
      meta: {
        toParentTitle: 'goBack',
        noWebNav: true,
        navWebTitle: '查看PDF',
        parentTitle: [
          {name: '我的预约', path: '/on-passage-application'},
          {name : '预约详情',path: '/application-detail_web'}
        ]
      },
    },
    // PC预览PDF
    {
      path: '/appointment-details-pdf',
      component: () => import('@/pages/mine/application/appointmentDetailsPdf/index.vue'),
      beforeEnter: requireAuth,
      meta: {
        navWebTitle: '查看PDF',
        parentTitle: [
          {name: '我的预约', path: '/on-passage-application'},
          {name : '预约详情',path: '/application-detail_web'}
        ]
      }
    },
    {
      path: '/document-renewal',
      component: () => import('@/pages/documentRenewal/index.vue'),
      beforeEnter: requireAuth,
      meta: {
        navWebTitle: '更新证件',
      },
    },
    {
      path: '/document-renewal/success-page',
      component: () => import('@/pages/documentRenewal/successPage.vue'),
      beforeEnter: requireAuth,
      meta: {
        navWebTitle: '更新证件成功',
      },
    },
  ]
})
window.stateArray = []


router.beforeEach((to, from, next) => {
  if (from.path !== '/submitSuccess') {
    next();
  }
})



router.afterEach((to, from, failure) => {
  // 当前跳转不是返回逻辑时，添加目标路由到stateArray，同时多添加一个目标路由到history
  // 如 A -> B，stateArray为 A,B。  history为 A,B,B
  pushHistory(to)
  if (!window.goBack) {
    window.stateArray.push(to)
  } else {
    window.goBack = false
  }
  if (to.meta.noBack) {
    window.stateArray = [to]
    window.browserBack = false
  } else {
    window.browserBack = false
  }

  console.log('to---', to)
  console.log('from---', from)

  try {
    const { webTracingData } = to.meta
    const tracingTitle = to.meta.webTracingName
    let tracingData = null;
    if (webTracingData) {
      tracingData = webTracingData;
    } else if (tracingTitle) {
      tracingData = {
        eventId: toCamelCase(to.path),
        title: tracingTitle,
      }
    }
    if (tracingData) {
      webTracing.traceCustomEvent(
        tracingData.eventId,
        tracingData.title,
        {
          fullPath: to.fullPath,
          query: to.query,
          // 手机和PC
          isMobile: windowMatchMobile(),
        }
      );
    }
  } catch(e) {
    console.log('埋点报错')
  }
})

function pushHistory(to) {
  let state = {
    title: 'title',
    url: to.path
  }
  window.history.pushState(state, 'title', '')
}
function setRedirectPath(to, from ,next) {
  if(isLocalStorageSupported()){
    localStorage.setItem("wechatUrl1", to.query.url)
  }
  next()
}
function isLocalStorageSupported () {
  var testKey = 'test'
  var storage = window.sessionStorage
  try {
    storage.setItem(testKey, 'testValue')
    storage.removeItem(testKey)
    console.log('支持本地存储')
    return true
  } catch (error) {
    console.log('不支持本地存储')
    return false
  }
}
export default router
